import React, { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

export default function ScrollToTopButton({
  showAfterPx = 420, // hero ke baad approx
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let raf = 0;

    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        setVisible(y > showAfterPx);
        raf = 0;
      });
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      if (raf) window.cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
    };
  }, [showAfterPx]);

  const goTop = () => {
    // smooth top
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={goTop}
      aria-label="Back to top"
      className={[
        "fixed z-[9999]",
        "right-6 bottom-6 md:right-8 md:bottom-8",
        "h-11 w-11 md:h-12 md:w-12",
        "rounded-[6px]",
        "bg-[#2FA0E6] hover:bg-[#1E88D6]",
        "shadow-[0_12px_28px_rgba(0,0,0,0.22)]",
        "border border-white/20",
        "grid place-items-center",
        "transition-all duration-300",
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-3 pointer-events-none",
      ].join(" ")}
    >
      <ChevronUp className="h-6 w-6 text-white" aria-hidden="true" />
    </button>
  );
}
